import PropTypes from "prop-types";
import Barcode from "react-barcode";

const BarcodeGenerator = ({ value }) => {
  return (
    <Barcode
      value={value}
      displayValue={false}
      width={1}
      height={27}
      background="transparent"
    />
  );
};

BarcodeGenerator.propTypes = {
  value: PropTypes.string.isRequired
};

export default BarcodeGenerator;
